module.exports = __webpack_public_path__ + "static/img/Bachelor_010335.35b82c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010335.jpg
// module id = 150
// module chunks = 0